import { z } from "zod";

export const ClienteArquivoSchema = z.object({
    idClienteArquivo: z.number().int().optional(),
    idCliente: z.number().int().optional(),
    nome: z.string().optional().nullable(),
    arquivo: z.instanceof(File).nullable().default(null),
    descricao: z.string().optional().nullable(),

    limparArquivo: z.boolean().default(false),

});

export type ClienteArquivoForm = z.infer<typeof ClienteArquivoSchema>;

export const defaultClienteArquivoForm: Partial<ClienteArquivoForm> = {
    idClienteArquivo: undefined,
    idCliente: undefined,
    nome: undefined,
    arquivo: undefined,
    descricao: undefined,

    limparArquivo: false,

};
